// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"480c4e17","845":"6803b2c0"}[chunkId] + ".chunk.js";
};